import { render, staticRenderFns } from "./VerAsignacionItems.vue?vue&type=template&id=98ea4b44&scoped=true&"
import script from "./VerAsignacionItems.vue?vue&type=script&lang=js&"
export * from "./VerAsignacionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ea4b44",
  null
  
)

export default component.exports